<ul class="layout-menu">
  <li app-menu-item *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
</ul>